class Circle {
  constructor (config) {
    this.color = config.color
    this.element = config.element
    this.ctx = config.ctx
    this.lineWidth = config.lineWidth
    this.radius = config.radius
    this.text = config.text
    this.percent = config.percent / 100 * 360 - 90
  }
  bgCircle () {
    const {ctx, lineWidth, radius, color, text} = this
    ctx.beginPath()
    ctx.moveTo(radius * 2, radius)
    ctx.lineWidth = lineWidth
    ctx.strokeStyle = '#ebf0f4'
    ctx.arc(radius, radius, radius - lineWidth / 2, 0, Math.PI * 2)
    ctx.closePath()
    ctx.stroke()

    ctx.font = '6.4vw PingFangSC'
    ctx.textAlign = 'center'
    ctx.textBaseLine = 'middle'
    ctx.fillStyle = color
    ctx.fillText(text[0], radius, radius - lineWidth)

    ctx.font = '7.466666667vw PingFangSC'
    ctx.textAlign = 'center'
    ctx.textBaseLine = 'middle'
    ctx.fillStyle = color
    ctx.fillText(text[1], radius, radius + lineWidth * 2)
  }
  animateCircle (timer, endAngle) {
    const {lineWidth, radius, ctx, color} = this
    if (endAngle > this.percent) {
      clearInterval(timer)
    }
    ctx.clearRect(0, 0, radius * 2, radius * 2)
    this.bgCircle()

    ctx.beginPath()
    ctx.moveTo(radius, lineWidth / 2)
    ctx.strokeStyle = color
    ctx.lineCap = 'round'
    ctx.arc(radius, radius, radius - lineWidth / 2, -90 * (Math.PI / 180), endAngle * (Math.PI / 180), false)
    ctx.stroke()
  }
  circleLauncher () {
    this.bgCircle()
    let percent = -90
    let timer = setInterval(() => {
      percent++
      this.animateCircle(timer, percent)
    }, 30)
  }
}
export default Circle



// WEBPACK FOOTER //
// ./src/lib/circle.js